// extracted by mini-css-extract-plugin
module.exports = {"row":"SsAutoCheckout_row__uTcN0"};